import React, { useState } from 'react';

import { Alert, Box, Button, Card, CardContent, FormControlLabel, Stack, Switch, Typography } from '@mui/material';

import { useUpsertBusinessSettings } from '~/hooks/apis/business-traveller/useBusinessSettings';

import { BusinessSettingsResponse } from '~/services/BusinessTraveller/BusinessTravellerService';

export type SabreSyncSettingDraft = Omit<NonNullable<BusinessSettingsResponse['sabre_sync']>, 'id'> & { id?: string };

interface Props {
  businessId: string;
  setting?: SabreSyncSettingDraft;
  disabled?: boolean;
}

export default function SabreSyncSettingForm({ businessId, setting, disabled }: Props) {
  const [enabled, setEnabled] = useState(setting?.value.enabled ?? false);
  const mutation = useUpsertBusinessSettings();
  const hasChanges = !setting?.id || enabled !== (setting?.value.enabled ?? false);

  return (
    <Card variant="outlined">
      <CardContent>
        <Stack gap={2}>
          <Typography variant="h6">Sabre sync</Typography>
          <Typography variant="body2">
            Enable Sabre profile sync for this business. While enabled, self-serve invitations are disabled and
            travellers must be managed through the traveller spreadsheet.
          </Typography>
          <FormControlLabel
            label="Sabre sync enabled"
            control={
              <Switch
                checked={enabled}
                onChange={(event) => setEnabled(event.target.checked)}
                disabled={disabled || mutation.isPending}
              />
            }
          />
          {mutation.isError && (
            <Alert severity="error">Unable to save Sabre sync. Your changes have not been saved.</Alert>
          )}
          <Box>
            <Button
              variant="contained"
              disabled={disabled || mutation.isPending || !hasChanges}
              onClick={() => mutation.mutate({ businessId, settings: { sabre_sync: { enabled } } })}
            >
              {mutation.isPending ? 'Saving...' : 'Save'}
            </Button>
          </Box>
        </Stack>
      </CardContent>
    </Card>
  );
}
